import { jsx } from "react/jsx-runtime";
const Facebook = ({ className = 'tw-text-neutral-light-800', size = 32 })=>/*#__PURE__*/ jsx("svg", {
        className: className,
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        children: /*#__PURE__*/ jsx("path", {
            d: "M14 2.5A5.5 5.5 0 0 0 8.5 8v1.5H6a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h2.5V21a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-6.5H16a.5.5 0 0 0 .485-.379l1-4A.5.5 0 0 0 17 9.5h-3.5V8a.5.5 0 0 1 .5-.5h3a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5h-3Z",
            fill: "none",
            className: "tw-fill-current"
        })
    });
const Facebook_Facebook = Facebook;
export default Facebook_Facebook;
